import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetrequestextraReducer(state = initialState.budgetrequestextraContent, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETREQUESTEXTRACONTENT_SUCCESS:
      return action.budgetrequestextraContent;
    default:
      return state;
  }
}
